import { useStore } from 'react-redux';
import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { all } from 'redux-saga/effects';

import * as card from './nodes/card';
import * as flipbook from './nodes/flipbook';
import * as lastPage from './nodes/lastPage';
import * as drawer from './nodes/drawer';
import * as share from './nodes/share';
import * as toast from './nodes/toast';
import * as gift from './nodes/gift';
import * as hint from './nodes/hint';
import * as promo from './nodes/promo';
import * as invitation from './nodes/invitation';

export {
  useStore,
};

export const createStore = () => {
  const sagaMiddleware = createSagaMiddleware();

  const getStoreConfig = () => {
    const result = {
      reducer: {
        card: card.reducer,
        flipbook: flipbook.reducer,
        lastPage: lastPage.reducer,
        drawer: drawer.reducer,
        toast: toast.reducer,
        share: share.reducer,
        gift: gift.reducer,
        hint: hint.reducer,
        promo: promo.reducer,
        invitation: invitation.reducer,
      },
      middleware: [...getDefaultMiddleware(), sagaMiddleware],
      preloadedState: undefined,
    };
    if (typeof window !== 'undefined') {
      const { __PRELOADED_STATE__: preloadedState } = (window as any);
      result.preloadedState = preloadedState;
    }
    return result;
  };

  function* sagas() {
    yield all([
      card.sagas(),
      lastPage.sagas(),
      toast.sagas(),
      gift.sagas(),
      hint.sagas(),
      promo.sagas(),
      invitation.sagas(),
    ]);
  }

  const store = ({
    ...configureStore(getStoreConfig()),
    saga: {
      run: sagaMiddleware.run,
    },
  });

  store.saga.run(sagas);

  return store;
};
